import { HANDLE_CHANGE_BENCHMARK_NORMS } from "../../../constants";


export const handleChangeNormBenchmarkData = (payload) => {
    return (dispatch) => {
        dispatch({ type: HANDLE_CHANGE_BENCHMARK_NORMS, payload });
    }
};